import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useNonceStyle from "@/utils/useNonceStyle";
const TaskActionsMenu = ({ onEdit, onDelete, onChangeState, taskStates, position, onClose, }) => {
    const positionClass = useNonceStyle({ top: `${position.y}px`, left: `${position.x}px` });
    return (_jsxs("div", { className: `absolute z-50 bg-white border rounded shadow-md text-sm ${positionClass}`, onClick: (e) => e.stopPropagation(), children: [_jsx("button", { className: "block w-full text-left px-2 py-1 hover:bg-gray-100", onClick: () => {
                    onEdit();
                    onClose();
                }, children: "Modifier" }), _jsx("button", { className: "block w-full text-left px-2 py-1 hover:bg-gray-100", onClick: () => {
                    onDelete();
                    onClose();
                }, children: "Supprimer" }), _jsx("div", { className: "border-t my-1" }), taskStates.map((state) => (_jsx("button", { className: "block w-full text-left px-2 py-1 hover:bg-gray-100", onClick: () => {
                    onChangeState(state.code);
                    onClose();
                }, children: state.label }, state.id)))] }));
};
export default TaskActionsMenu;
